// extracted by mini-css-extract-plugin
export var cell = "_6m-4";
export var headerCell = "_6m-2";
export var rowHeader = "_6m-3";
export var table = "_6m-1";
export var tableContainer = "_6m-0";